import type { KeyboardEvent } from 'react';

/** Automatic activation for the horizontal reading tabs, including their return path. */
export function handleScenarioTabsKeyDown(event: KeyboardEvent<HTMLDivElement>) {
  const tabs = [...event.currentTarget.querySelectorAll<HTMLButtonElement>('[role="tab"]')];
  const current = tabs.findIndex((tab) => tab === event.target);
  if (current < 0) return;
  let next: number;
  switch (event.key) {
    case 'ArrowRight':
      next = (current + 1) % tabs.length;
      break;
    case 'ArrowLeft':
      next = (current - 1 + tabs.length) % tabs.length;
      break;
    case 'Home':
      next = 0;
      break;
    case 'End':
      next = tabs.length - 1;
      break;
    default:
      return;
  }
  event.preventDefault();
  tabs[next]?.focus();
  tabs[next]?.click();
}
